/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import LoginLogo from '../assets/img/brand-icon.png';
import { loginStepOne, loginStepTwo } from '../services/auth';
import { useHistory } from 'react-router-dom';
import {
  setToken,
  setUserData,
  showToast,
  setLocation,
  setUserRole,
} from '../redux/auth/auth.action';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Footer from '../comman/component/footer';
import jwt from 'jwt-decode';
import { updateUser, updateUserPassword } from '../services/user';

const ResetPassword = ({ setToaster }) => {
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');

  const user = jwt(token);

  const history = useHistory();
  const [buttonEvent, setButtonEvent] = useState(false);

  const initialValues = {
    password: '',
    verifyPassword: '',
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string().required('New Password is required'),
    verifyPassword: Yup.string().oneOf(
      [Yup.ref('password'), null],
      'Passwords must match'
    ),
  });

  const submitFunction = async (value) => {
    const data = {
      token,
      password: value.password,
    };
    const userId = user.userId;
    const response = await updateUserPassword(token, data);

    setButtonEvent(true);
    // const response = await loginStepOne(value);
    if (response.status === 200) {
      const data = {
        show: true,
        message: 'Password Updated Successfully',
      };
      setToaster(data);
      // history.push("/");
      window.setTimeout(() => {
        history.push('/');
      }, 1000);
      // await setToken(response.data.token);
      // await setLocation(response.data.location);
      // const responseStepTwo = await loginStepTwo();
      // if (responseStepTwo.status === 200) {
      //   await setUserRole(
      //     responseStepTwo.data.userProfile.localizations.name.en.value
      //   );
      //   await setUserData(responseStepTwo.data);
      //   history.push("/index");
      // }
    } else {
      const data = {
        show: true,
        message: 'Bad Credentials',
      };
      setToaster(data);
    }
    setButtonEvent(false);
  };

  return (
    <div id='pageWrapper'>
      <section className='sign-in-sec'>
        <div className='login-content-wrapper'>
          <div className='login-content-inner'>
            <div className='img'>
              <img src={LoginLogo} alt='' />
            </div>
            <div className='login-fileds'>
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(value) => submitFunction(value)}>
                {({ submitForm }) => (
                  <Form>
                    <div className='login-form'>
                      <div className='input-item'>
                        <Field
                          type='password'
                          name='password'
                          placeholder='New Password'
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              submitForm();
                            }
                          }}
                        />
                        <ErrorMessage name='password'>
                          {(msg) => (
                            <span className='fm_error' style={{ color: 'red' }}>
                              {msg}
                            </span>
                          )}
                        </ErrorMessage>
                      </div>
                      <div className='input-item'>
                        <Field
                          type='password'
                          name='verifyPassword'
                          placeholder='Verify Password'
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              submitForm();
                            }
                          }}
                        />
                        <ErrorMessage name='verifyPassword'>
                          {(msg) => (
                            <span className='fm_error' style={{ color: 'red' }}>
                              {msg}
                            </span>
                          )}
                        </ErrorMessage>
                      </div>
                      <div className='input-item login'>
                        <button type='submit'>Reset Password</button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className='website-about-links'>
            <a
              href='https://ringerinteractive.com/privacy-policy/'
              target='_blank'
              rel='noreferrer'>
              Privacy Policy
            </a>
            {' | '}
            <a
              href='https://ringerinteractive.com/terms-and-conditions/'
              target='_blank'
              rel='noreferrer'>
              Terms of Service
            </a>
            {' | '}
            <a
              href='https://ringerinteractive.com/eula/'
              target='_blank'
              rel='noreferrer'>
              License Agreement
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setToken: (data) => dispatch(setToken(data)),
  setUserData: (data) => dispatch(setUserData(data)),
  setToaster: (data) => dispatch(showToast(data)),
  setLocation: (data) => dispatch(setLocation(data)),
  setUserRole: (data) => dispatch(setUserRole(data)),
});

export default connect(null, mapDispatchToProps)(ResetPassword);
